import { createI18n } from 'vue-i18n'
import zh from './locales/zh/index'
import en from './locales/en/index'
import ja from './locales/ja/index'
import ko from './locales/ko/index'

/**
 * 获取默认语言
 * Get default locale from localStorage or browser settings
 */
const getDefaultLocale = () => {
  // 1. 优先从 localStorage 获取用户选择的语言
  const savedLocale = localStorage.getItem('language')
  if (savedLocale && ['zh', 'en', 'ja', 'ko'].includes(savedLocale)) {
    return savedLocale
  }

  // 2. 无用户缓存时，默认使用英语
  return 'en'
}

const messages = {
  zh,
  en,
  ja,
  ko
}

const i18n = createI18n({
  legacy: false, // 使用 Composition API 模式
  locale: getDefaultLocale(), // 默认语言
  fallbackLocale: 'en', // 备用语言为英语
  messages,
  // 添加缺失翻译警告（开发环境）
  missingWarn: false, // 暂时禁用警告
  fallbackWarn: false, // 暂时禁用警告
  // 全局注入 $t
  globalInjection: true,
  // 忽略格式错误
  silentTranslationWarn: true,
  silentFallbackWarn: true
})

export default i18n
